import moment from 'moment-timezone';
import { types as sdkTypes } from 'util/sdkLoader';
import { hasMergedTimeSlot } from './hasMergedTimeSlot';

const { UUID } = sdkTypes;

const checkDayHasContinuousSlot = (dayPlan) => {
  for (let i = 1; i < dayPlan.length; i++) {
    const prev = dayPlan[i - 1];
    const current = dayPlan[i];
    if (prev.endTime >= current.startTime) {
      return true;
    }
  }
  return false;
};

/* eslint-disable import/prefer-default-export */
export const splitMergedTimeSlot = ({ availabilityPlan, timeSlots }) => {
  if (
    !Array.isArray(timeSlots) ||
    timeSlots.length === 0 ||
    !availabilityPlan ||
    !hasMergedTimeSlot(availabilityPlan)
  ) {
    return timeSlots;
  }

  return timeSlots.reduce((acc, currentTimeSlot) => {
    const {
      id,
      type,
      attributes: { start, end, seats, type: slotType },
    } = currentTimeSlot;
    const startMoment = moment(start).tz('Europe/London');
    const endMoment = moment(end).tz('Europe/London');

    const dayOfWeek = startMoment.format('ddd').toLowerCase();
    const dayPlan = availabilityPlan.entries.filter((entry) => entry.dayOfWeek === dayOfWeek);
    const sortedDayPlan = dayPlan.slice().sort((a, b) => a.startTime - b.startTime);

    if (dayPlan.length < 1) {
      acc.push(currentTimeSlot);
      return acc;
    }

    const hasContinuousSlotInDay = checkDayHasContinuousSlot(sortedDayPlan);

    if (!hasContinuousSlotInDay) {
      acc.push(currentTimeSlot);
      return acc;
    }

    const startTimeInMinuteFormat = startMoment.format('HH:mm');
    const endTimeInMinuteFormat = endMoment.format('HH:mm');

    const indexOfStartEntry = sortedDayPlan.findIndex(
      (entry) => entry.startTime === startTimeInMinuteFormat
    );
    const indexOfEndEntry = sortedDayPlan.findIndex(
      (entry) => entry.endTime === endTimeInMinuteFormat
    );

    if (
      indexOfStartEntry === -1 ||
      indexOfEndEntry === -1 ||
      indexOfStartEntry === indexOfEndEntry
    ) {
      acc.push(currentTimeSlot);
      return acc;
    }

    const splitSlots = [];

    for (let i = indexOfStartEntry; i <= indexOfEndEntry; i++) {
      const entry = sortedDayPlan[i];
      const slotStartMoment = startMoment
        .clone()
        .tz('Europe/London')
        .set({
          hour: parseInt(entry.startTime.split(':')[0], 10),
          minute: parseInt(entry.startTime.split(':')[1], 10),
        });
      const slotEndMoment = startMoment
        .clone()
        .tz('Europe/London')
        .set({
          hour: parseInt(entry.endTime.split(':')[0], 10),
          minute: parseInt(entry.endTime.split(':')[1], 10),
        });
      splitSlots.push({
        id: new UUID(`${id.uuid}-${i}`),
        type,
        attributes: {
          start: slotStartMoment.toDate(),
          end: slotEndMoment.toDate(),
          seats,
          type: slotType,
        },
      });
    }

    return acc.concat(splitSlots);
  }, []);
};
